// components
import SummaryContainer from 'components/checkout/containers/summary/summary-container';

export function Step2() {

  return (
    <SummaryContainer />
  );
}
